export default "__VITE_ASSET__CjiTYiD3__"